import { MovementLifecycleStates, TaskLifecycleStates } from '@skinsoft/entity';
import { LinkableItemLifecycleStates } from '@skinsoft/entity-data-store';

export const messages = {
    en: {
        auth: {
            login: {
                error: {
                    credentials: 'Your credentials are incorrect',
                    network: 'Communication with server failed',
                },
                form: {
                    password: {
                        error: `Please enter your User ID`,
                        label: `Password`,
                    },
                    submit: 'Log in',
                    submitting: 'Logging in',
                    username: {
                        error: `Please enter your password`,
                        label: `User ID`,
                    },
                },
            },
            renew: {
                slowNetwork: `This is taking a bit longer than usual, please do not log out`,
                spinner: 'We are getting you back online',
            },
        },
        dashboard: {
            movement: { title: 'Latest movements', emptyMessage: 'No movement to process' },
            task: { title: 'Latest tasks', emptyMessage: 'No task to process' },
        },
        entity: {
            actionMenu: {
                movement: {
                    addItem: 'Add object',
                    cancel: 'Cancel movement',
                    close: 'Finalize movement',
                    return: 'Create return movement',
                },
                noActions: 'No actions available',
                task: {
                    createMovement: 'Create a movement from this task',
                },
            },
            addItem: {
                error: {
                    api: `The object could not be added`,
                    network: 'Communication with server failed',
                },
                form: {
                    id: {
                        alreadyAdded: `The object has already been added to this movement`,
                        emptyError: `Please scan an object`,
                        label: `Inventory number`,
                        notFoundError: `Object is unknown`,
                    },
                    location: {
                        emptyError: `Please select a location`,
                        label: `Arrival location`,
                        notFoundError: `Location is unknown`,
                    },
                    submit: 'Add',
                    submitting: 'Adding',
                },
                modal: {
                    title: 'Add object',
                },
            },
            cancelMovement: 'Do you want to cancel this movement?',
            closeMovement: {
                error: {
                    api: `The movement could not be finalized`,
                    network: 'Communication with server failed',
                },
                form: {
                    location: {
                        emptyError: `Please select a location`,
                        label: `Arrival location`,
                        notFoundError: `Location unknown`,
                    },
                    permanentLocation: {
                        label: `Use as permanent location`,
                    },
                    submit: 'Finalize',
                    submitting: 'Finalizing',
                },
                modal: {
                    cannotBeClosed: `The movement current status does not allow for finalization`,
                    noItems: `You have not validated any object`,
                    title: 'Finalize the movement',
                },
            },
            createReturnMovement: 'Do you want to create a return movement from this movement?',
            noItems: 'No object is linked',
        },
        entityList: {
            actionMenu: {
                movement: {
                    create: 'Create a movement',
                },
            },
            movement: {
                createMovement: 'Do you want to create a movement?',
                featuredEmptyMessage: 'No movement found',
                featuredTitle: 'Latest movements',
                field: {
                    author: 'Author',
                    endDate: 'End date',
                    startDate: 'Request',
                    title: 'Title',
                },
                historyTitle: 'Movements history',
            },
            task: {
                featuredEmptyMessage: 'No task found',
                featuredTitle: 'Latest tasks',
                field: {
                    author: 'Author',
                    endDate: 'End date',
                    startDate: 'Request',
                    title: 'Title',
                },
                historyTitle: 'Tasks history',
            },
        },
        featuredCard: {
            authorEmpty: `No author`,
            authorError: `Impossible to retrieve the author`,
        },
        itemCard: {
            detailsNotAvailable: 'Details not available',
            error: `Object cannot be displayed`,
            identifier: 'Inventory Number {identifier}',
            identifierError: `Identification error`,
            locationLabel: 'Destination: <strong>{title}</strong>',
            rollback: 'Do you want to reset this object?',
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Deployed on',
                checkForUpdate: {
                    help: `If an update is available, it will automatically be installed`,
                    title: 'Please check updates',
                },
                clearCache: {
                    help: `If you are offline, it will block the access to all the data stored in the device`,
                    title: 'Empty cache',
                },
                overrideLocale: {
                    help: `English language will be used, overriding your device settings`,
                    title: `Override locale with ENGLISH`,
                },
                resetLocaleOverride: {
                    help: `Your device language settings will be used to set the application language`,
                    title: 'Reset locale override',
                },
                title: 'Skin-REPORTER',
            },
            logout: 'Do you want to log out?',
        },
        offlineRibbon: {
            offline: 'You are now logged out',
        },
        proxy: {
            error: {
                default: `An error occurred on the resource`,
                network: 'Communication with server failed',
                notFound: `Resource not found`,
            },
        },
        serviceWorker: {
            updateAvailable: `An update has been installed. Please click here to refresh the page or restart the application`,
        },
    },
    fr: {
        auth: {
            login: {
                error: {
                    credentials: 'Vos identifiants sont incorrects',
                    network: 'La communication avec le serveur a échoué',
                },
                form: {
                    password: {
                        error: `Veuillez saisir votre nom d'utilisateur`,
                        label: `Mot de passe`,
                    },
                    submit: 'Se connecter',
                    submitting: 'Connexion...',
                    username: {
                        error: `Veuillez saisir votre mot de passe`,
                        label: `Nom d'utilisateur`,
                    },
                },
            },
            renew: {
                slowNetwork: `Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.`,
                spinner: 'Nous vous reconnectons...',
            },
        },
        entity: {
            actionMenu: {
                movement: {
                    addItem: 'Ajouter un objet',
                    cancel: 'Annuler le mouvement',
                    close: 'Clôturer le mouvement',
                    return: 'Créer un mouvement retour',
                },
                noActions: 'Aucune action possible',
                task: {
                    createComplexMovement: 'Créer un mouvement complexe',
                    createSimpleMovement: 'Créer un mouvement simple',
                    rejectTask: 'Rejeter la tâche',
                    startTask: 'Démarrer la tâche',
                },
            },
            addItem: {
                error: {
                    api: `L'objet n'a pas pu être ajouté`,
                    network: 'La communication avec le serveur a échoué',
                },
                form: {
                    id: {
                        alreadyAdded: `L'objet est déjà existant dans le mouvement`,
                        emptyError: `Veuillez scanner un objet`,
                        label: `Numéro d'inventaire`,
                        notFoundError: `L'objet est inconnu`,
                    },
                    submit: 'Ajouter',
                    submitting: 'Ajout...',
                },
                modal: {
                    title: 'Ajouter un objet',
                },
            },
            cancelMovement: 'Etes-vous sûr de vouloir annuler ce mouvement ?',
            closeMovement: {
                error: {
                    api: `Le mouvement n'a pas pu être clôturé`,
                    network: 'La communication avec le serveur a échoué',
                },
                form: {
                    location: {
                        emptyError: `Veuillez sélectionner une localisation`,
                        label: `Localisation d'arrivée`,
                        notFoundError: `La localisation est inconnue`,
                    },
                    permanentLocation: {
                        label: `Utiliser comme localisation permanente`,
                    },
                    submit: 'Clôturer',
                    submitting: 'Clôture...',
                },
                modal: {
                    cannotBeClosed: `Le mouvement n'est pas dans un état permettant d'être clôturé`,
                    noItems: `Vous n'avez validé aucun objet`,
                    title: 'Clôturer le mouvement',
                },
            },
            createMovementFromTask:
                'Etes-vous sûr de vouloir créer un mouvement à partir de cette tâche ?',
            createReturnMovement:
                'Etes-vous sûr de vouloir créer un mouvement retour à partir de ce mouvement ?',
            noItems: "Aucun objet n'est associé",
        },
        entityHistory: {
            field: {
                author: `Auteur`,
                date: `Clôture`,
                description: `Titre`,
                title: `#`,
            },
        },
        entityList: {
            actionMenu: {
                movement: {
                    create: 'Créer un mouvement',
                },
            },
            movement: {
                createMovement: 'Etes-vous sûr de vouloir créer un mouvement ?',
            },
        },
        featuredCard: {
            authorEmpty: `Aucun auteur`,
            authorError: `Impossible de récuperer l'auteur`,
            dateEmpty: `Pas de date disponible`,
            descriptionEmpty: `-`,
            headerDateEmpty: `Pas de date disponible`,
            titleEmpty: `-`,
        },
        itemCard: {
            detailsNotAvailable: 'Détails non disponible',
            error: `L'objet ne peut pas être affiché`,
            identifier: 'N° Inv. {identifier}',
            locationLabel: 'Destination: <strong>{title}</strong>',
        },
        movement: {
            createModal: {
                form: {
                    motive: 'Motif',
                    motiveMissing: 'Vous devez sélectionner un motif',
                    submit: 'Créer le mouvement',
                    submitting: 'Création...',
                    title: 'Titre du mouvement',
                    titleMissing: 'Vous devez saisir un titre',
                },
                title: 'Nouveau mouvement',
            },
            entity: {
                associatedTask: 'Tâche associée :',
                empty: `Le mouvement ne contient pas d'objet`,
            },
            featuredList: {
                emptyMessage: 'Aucun mouvement disponible',
                title: 'Mouvements',
            },
            history: {
                emptyMessage: 'Aucun movement archivé',
                title: 'Historique des mouvements',
            },
            itemCard: {
                arrivalLocation: `Localisation d'arrivée`,
                identifier: `Numéro d'inventaire`,
                identifierError: `Erreur d'identification`,
                locationHint: 'Localisation habituelle',
                revertButton: `Annuler`,
                revertPrompt: `Etes-vous sûr de vouloir réinitialiser cet objet ?`,
                revertingButton: `Annulation...`,
                state: {
                    [LinkableItemLifecycleStates.IN_TRANSIT]: `Cet objet est en transit`,
                    [LinkableItemLifecycleStates.FINALIZED]: `Cet objet est livré`,
                },
            },
            state: {
                [MovementLifecycleStates.ARCHIVED]: 'Archivé',
                [MovementLifecycleStates.CANCELED]: 'Annulé',
                [MovementLifecycleStates.FINALIZED]: 'Terminé',
                [MovementLifecycleStates.IN_PREPARATION]: 'En préparation',
                [MovementLifecycleStates.IN_PROGRESS]: 'En cours',
                [MovementLifecycleStates.PROGRAMMED]: 'Planifié',
            },
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Déployé le',
                checkForUpdate: {
                    help: `Si une mise à jour est disponible, elle s'installera automatiquement.`,
                    title: 'Vérifiez les mises à jour',
                },
                clearCache: {
                    help: `Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.`,
                    title: 'Vider le cache',
                },
                overrideLocale: {
                    help: `La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.`,
                    title: `Forcer la langue anglaise`,
                },
                resetLocaleOverride: {
                    help: `La langue utilisé dépendra du paramètrage de votre terminal`,
                    title: 'Réinitialiser la langue',
                },
                title: 'Skin-REPORTER',
            },
            logout: 'Etes-vous sûr de vouloir vous déconnecter ?',
        },
        offlineRibbon: {
            offline: 'Vous êtes hors connexion',
        },
        proxy: {
            error: {
                default: `Une erreur s'est produite sur la resource {uri}`,
                network: 'La communication avec le serveur a échoué',
                notFound: `La ressource {uri} n'a pas été trouvée`,
                tokenHasExpired: `Votre session a expiré`,
            },
        },
        serviceWorker: {
            updateAvailable: `Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application`,
        },
        task: {
            entity: {
                commentEditorPlaceholder: 'Saisissez un commentaire concernant cette tâche...',
                empty: `La tâche ne contient pas d'objet`,
                hasPendingMovement: 'Création du mouvement en cours...',
            },
            featuredList: {
                emptyMessage: 'Aucune tâche disponible',
                title: 'Tâches',
            },
            history: {
                emptyMessage: 'Aucune tâche archivée',
                title: 'Historique des tâches',
            },
            state: {
                [TaskLifecycleStates.FINALIZED]: 'Terminé',
                [TaskLifecycleStates.IN_PROGRESS]: 'En cours',
                [TaskLifecycleStates.PLANNED]: 'Planifié',
            },
        },
    },
};

export const dateTimeFormats = {
    fr: {
        short: {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        },
        shortTime: {
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            month: '2-digit',
            second: 'numeric',
            year: 'numeric',
        },
        year: {
            year: 'numeric',
        },
    },
};
